import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import { useTranslation } from "react-i18next";
import DeleteForm from "../components/DeleteForm";
import { translate } from "../utils/utils";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import WeaknessesDetails from "../pages/weaknesses/WeaknessesDetails";
import AssetsDetails from "../pages/asset/AssetDetails";
import { useHistory } from "react-router-dom";
import NoData from "../assets/noAssets.png";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F3FBF9",
    color: "#B1B4BC",
    height: "50px",
    padding: "0px 16px 0px 16px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {},
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CustomizedTables({
  data,
  disabled,
  head,
  type,
  handleOpen,
  handleData,
  handleUpdate,
  id_owner,
  company,
  riskAsset,
  riskWeakness,
  risk,
  handleOpenDetails,
  myAssets,
  orgaName,
  enterprise,
  accountType,
  handleOpenAssignModal,
  orgaAssetAssinged,
  userRole,
  page,
  handlePage,
  totalPages,
  searchText,
  filter,
  mySource,
}) {
  const history = useHistory();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openWeakness, setOpenWeakness] = useState(false);
  const [openAsset, setOpenAsset] = useState(false);
  const [rowDetails, setRowDetails] = useState({});
  const [id, setId] = useState("");

  const storedUser = localStorage.getItem("user");
  const accountId = JSON.parse(storedUser)?.account_id;

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseWeakness = () => {
    setOpenWeakness(false);
  };

  const handleCloseAsset = () => {
    setOpenAsset(false);
  };

  const handleSelectedWeakness = (row) => {
    setOpenWeakness(true);
    setId(row.id);
  };

  const handleSelectedAsset = (row) => {
    setOpenAsset(true);
    setId(row.id);
  };

  const handleSelectedRisk = (row) => {
    history.push(`/risk/${row.id}`);
    setId(row.id);
    handleData(row);
  };

  const role =
    JSON.parse(storedUser).role === "admin" ||
    JSON.parse(storedUser).role === "enterprise_user" ||
    JSON.parse(storedUser).role === "cytailor_admin" ||
    JSON.parse(storedUser).role === "enterprise_admin";

  return (
    <div>
      <TableContainer
        component={Paper}
        className="scrollhost"
        sx={{
          marginBottom: "20px",
          width: "100%",
          height: "500px",
          overflowY: "scroll",
          "&.MuiTableContainer-root": {
            borderRadius: "0px",
            boxShadow: "none",
          },
        }}
      >
        {data?.length === 0 ? (
          <>
            <Table
              aria-label="customized table"
              sx={{
                "& .MuiTableRow-root:hover": {
                  backgroundColor: "#DDF6F0",
                  cursor: "pointer",
                },
              }}
            >
              <TableHead>
                <TableRow>
                  {head.map((el, i) => (
                    <StyledTableCell
                      key={`asset${i}`}
                      align={el.align}
                      width={el.width}
                    >
                      {el.value}
                    </StyledTableCell>
                  ))}
                  <StyledTableCell align="right">
                    {" "}
                    {riskAsset && role ? (
                      <Button
                        variant="contained"
                        color="button"
                        disabled={disabled}
                        onClick={() => handleOpenDetails("asset")}
                        fullWidth
                        sx={{ height: "35px", width: "40%", fontSize: "13px" }}
                      >
                        <AddOutlinedIcon sx={{ width: "15px" }} />
                        {t("asset")}
                      </Button>
                    ) : riskWeakness && role ? (
                      <Button
                        variant="contained"
                        color="button"
                        fullWidth
                        onClick={() => handleOpenDetails("weakness")}
                        disabled={disabled}
                        sx={{ height: "35px", width: "50%", fontSize: "13px" }}
                      >
                        <AddOutlinedIcon sx={{ width: "15px" }} />
                        {t("weakness")}
                      </Button>
                    ) : null}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
            </Table>
            <Grid container sx={{ textAlign: "center", mt: "100px" }}>
              <Grid item xs={12}>
                <Typography variant="title">No Data Found</Typography>
              </Grid>
              <Grid item xs={12}>
                <img src={NoData} alt="No Data" />
              </Grid>
            </Grid>
          </>
        ) : (
          <Table
            stickyHeader
            aria-label="customized table"
            sx={{
              "& .MuiTableRow-root:hover": {
                backgroundColor: "#DDF6F0",
                cursor: "pointer",
              },
            }}
          >
            <TableHead>
              <TableRow>
                {head.map((el, i) => (
                  <StyledTableCell
                    key={`weakness${i}`}
                    align={el.align}
                    width={el.width}
                  >
                    {el.value}
                  </StyledTableCell>
                ))}
                <StyledTableCell align={"right"}>
                  {" "}
                  {riskAsset && !disabled && role ? (
                    <Button
                      variant="contained"
                      color="button"
                      fullWidth
                      disabled={disabled}
                      onClick={() => handleOpenDetails("asset")}
                      sx={{ height: "35px", width: "40%", fontSize: "13px" }}
                    >
                      <AddOutlinedIcon sx={{ width: "15px" }} />
                      {t("asset")}
                    </Button>
                  ) : riskWeakness && !disabled && role ? (
                    <Button
                      variant="contained"
                      color="button"
                      disabled={disabled}
                      onClick={() => handleOpenDetails("weakness")}
                      fullWidth
                      sx={{ height: "35px", width: "50%", fontSize: "13px" }}
                    >
                      <AddOutlinedIcon sx={{ width: "15px" }} />
                      {t("weakness")}
                    </Button>
                  ) : null}
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(() => {
                switch (type) {
                  case "asset":
                    return data?.map((row) => (
                      <StyledTableRow
                        key={row?.id}
                        hover
                        onClick={() => {
                          handleSelectedAsset(row);
                          handleData(row);
                        }}
                        role="checkbox"
                        tabIndex={-1}
                      >
                        <StyledTableCell align="left">
                          <Typography variant="title3">
                            {row?.[translate("title")] || t("not_specified")}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row?.value}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row?.source}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {(riskAsset || myAssets) && role && (
                            <Grid container>
                              {accountType === "enterprise" &&
                                !riskAsset &&
                                !orgaAssetAssinged && (
                                  <Grid xs={4}>
                                    <Tooltip title={t("assign_orga")}>
                                      <Button
                                        variant="outlined"
                                        color="info"
                                        disabled={
                                          (userRole === "enterprise_admin" ||
                                          userRole === "cytailor_admin"
                                            ? row?.related_account_id !==
                                              accountId
                                            : userRole === "enterprise_user"
                                            ? row?.source !== orgaName
                                            : row?.organization_id !==
                                              id_owner) && !riskAsset
                                        }
                                        size="small"
                                        sx={{ height: "40px", width: "85%" }}
                                        onClick={(e) => {
                                          handleOpenAssignModal(true);
                                          e.stopPropagation();
                                          handleData(row);
                                        }}
                                      >
                                        <AccountTreeOutlinedIcon />
                                        {}
                                      </Button>
                                    </Tooltip>
                                  </Grid>
                                )}
                              <Grid
                                xs={
                                  accountType === "enterprise" &&
                                  !riskAsset &&
                                  !orgaAssetAssinged
                                    ? 4
                                    : 6
                                }
                              >
                                {!riskAsset &&
                                  JSON.parse(storedUser)?.account_type !==
                                    "free" && (
                                    <Button
                                      variant="outlined"
                                      color="button"
                                      size="small"
                                      sx={{
                                        height: "40px",
                                        width: "80%",
                                      }}
                                      onClick={(e) => {
                                        handleOpen();
                                        handleData(row);
                                        handleUpdate();
                                        e.stopPropagation();
                                      }}
                                    >
                                      <ModeEditOutlineOutlinedIcon />
                                    </Button>
                                  )}
                              </Grid>

                              <Grid
                                xs={
                                  accountType === "enterprise" &&
                                  !riskAsset &&
                                  !orgaAssetAssinged
                                    ? 4
                                    : 6
                                }
                              >
                                <Button
                                  variant="outlined"
                                  color="deleteButton"
                                  size="small"
                                  disabled={
                                    (userRole === "enterprise_admin" ||
                                    userRole === "cytailor_admin"
                                      ? row?.related_account_id !== accountId
                                      : userRole === "enterprise_user"
                                      ? row?.source !== orgaName
                                      : row?.organization_id !== id_owner) &&
                                    !riskAsset
                                  }
                                  sx={{
                                    height: "40px",
                                    width: "85%",
                                  }}
                                  onClick={(e) => {
                                    setOpen(true);
                                    e.stopPropagation();
                                    setRowDetails(row);
                                    setId(row.id);
                                  }}
                                >
                                  <DeleteForeverOutlinedIcon />
                                  {}
                                </Button>
                              </Grid>
                            </Grid>
                          )}
                        </StyledTableCell>
                      </StyledTableRow>
                    ));
                  case "weakness":
                    return data?.map((row) => (
                      <StyledTableRow
                        key={row?.id}
                        hover
                        onClick={() => {
                          setRowDetails(row);
                          handleSelectedWeakness(row);
                          handleData(row);
                        }}
                        role="checkbox"
                        tabIndex={-1}
                      >
                        <StyledTableCell align="left">
                          <Typography variant="title3">
                            {row?.[translate("title")] || t("not_specified")}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row?.source}
                        </StyledTableCell>
                        <Tooltip
                          title={
                            row?.[translate("description")] ||
                            t("not_specified")
                          }
                        >
                          <StyledTableCell align="left">
                            {row?.description &&
                              `${
                                row?.[translate("description")]?.substring(
                                  0,
                                  30
                                ) || t("not_specified")
                              } ...`}
                          </StyledTableCell>
                        </Tooltip>

                        <StyledTableCell align="center">
                          {row?.related_account_id === accountId &&
                            enterprise &&
                            role && (
                              <Grid container>
                                <Grid xs={6}>
                                  {enterprise && (
                                    <Button
                                      variant="outlined"
                                      color="button"
                                      size="small"
                                      sx={{ height: "40px", width: "90%" }}
                                      disabled={disabled}
                                      onClick={(e) => {
                                        handleOpen();
                                        handleData(row);
                                        handleUpdate();
                                        e.stopPropagation();
                                      }}
                                    >
                                      <ModeEditOutlineOutlinedIcon /> &nbsp;{" "}
                                    </Button>
                                  )}
                                </Grid>

                                <Grid xs={6}>
                                  <Button
                                    variant="outlined"
                                    color="deleteButton"
                                    size="small"
                                    disabled={disabled}
                                    sx={{
                                      height: "40px",
                                      width: "80%",
                                    }}
                                    onClick={(e) => {
                                      setOpen(true);
                                      setRowDetails(row);
                                      setId(row.id);
                                      e.stopPropagation();
                                    }}
                                  >
                                    <DeleteForeverOutlinedIcon />
                                  </Button>
                                </Grid>
                              </Grid>
                            )}
                        </StyledTableCell>
                      </StyledTableRow>
                    ));
                  case "risk":
                    return data?.map((row) => (
                      <StyledTableRow
                        key={row.id}
                        hover
                        onClick={() => {
                          handleSelectedRisk(row);
                        }}
                        role="checkbox"
                        tabIndex={-1}
                      >
                        <StyledTableCell align="left">
                          <Typography variant="title3">
                            {row?.[translate("title")] || t("not_specified")}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row?.source}
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          {row?.assets?.length}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row?.weaknesses?.length}
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          {row?.related_account_id === accountId &&
                            role &&
                            mySource && (
                              <Grid container>
                                <Grid xs={6}>
                                  <Button
                                    variant="outlined"
                                    color="button"
                                    size="small"
                                    sx={{ height: "40px", width: "90%" }}
                                    onClick={(e) => {
                                      handleOpen();
                                      handleData(row);
                                      handleUpdate();
                                      e.stopPropagation();
                                    }}
                                  >
                                    <ModeEditOutlineOutlinedIcon />
                                  </Button>
                                </Grid>
                                <Grid xs={6}>
                                  <Button
                                    variant="outlined"
                                    color="deleteButton"
                                    size="small"
                                    sx={{ height: "40px", width: "105%" }}
                                    onClick={(e) => {
                                      setOpen(true);
                                      e.stopPropagation();
                                      setRowDetails(row);
                                      setId(row.id);
                                    }}
                                  >
                                    <DeleteForeverOutlinedIcon />
                                  </Button>
                                </Grid>
                              </Grid>
                            )}
                        </StyledTableCell>
                      </StyledTableRow>
                    ));
                  default:
                    return "Empty";
                }
              })()}
            </TableBody>
          </Table>
        )}
        <DeleteForm
          open={open}
          handleClose={handleClose}
          id={id}
          rowDetails={rowDetails}
          type={type}
          riskAsset={riskAsset}
          riskWeakness={riskWeakness}
          risk={risk}
          orgaAssetAssinged={orgaAssetAssinged}
          accountId={accountId}
          accountType={accountType}
          userRole={userRole}
          page={page}
          searchText={searchText}
          filter={filter}
        />
        <WeaknessesDetails
          open={openWeakness}
          handleClose={handleCloseWeakness}
          disabled={disabled}
          handleOpen={handleOpen}
          handleUpdate={handleUpdate}
          id={id}
          rowDetails={rowDetails}
          id_owner={id_owner}
          company={company}
          show={!riskWeakness}
        />
        <AssetsDetails
          open={openAsset}
          handleClose={handleCloseAsset}
          disabled={disabled}
          handleOpen={handleOpen}
          handleUpdate={handleUpdate}
          id={id}
          data={data}
          id_owner={id_owner}
          company={company}
          show={!riskAsset}
        />
      </TableContainer>
      <Stack spacing={2} justifyContent="right" direction="row">
        <Pagination
          count={totalPages}
          page={page}
          onChange={(e, p) => handlePage(p)}
          variant="outlined"
          shape="rounded"
          color="secondary"
        />
      </Stack>
    </div>
  );
}
